module.exports = __webpack_public_path__ + "images/2d468bf9e94042e22c4d95c7b74913c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/images/intro_video/tour_berlin/dan_thumb.jpg
// module id = 160
// module chunks = 24